var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Etime"},[_c('div',{staticClass:"Etime-content"},[_vm._v(_vm._s(_vm.content))]),_c('div',{attrs:{"enter-class":"Etime-times"}},[_vm._v("距离报价截止还剩"),_c('span',{staticClass:"Etime-times--highLight"},[_vm._v(_vm._s(_vm.hour)+"小时"+_vm._s(_vm.minute)+"分"+_vm._s(_vm.second)+"秒")]),_vm._v(",请耐心等待")])])
}
var staticRenderFns = []

export { render, staticRenderFns }